import React from "react";

import Helmet from "react-helmet";

import styled from "@emotion/styled";

import Box from "../../shared/Box";
import Columns from "../../shared/Columns";
import Container from "../../shared/Container";
import LinkComponent from "../../shared/LinkComponent";
import Robots from "../../shared/Meta/Robots";
import Headline from "../../shared/NewHeadline";
import Page from "../../shared/Page";

const LinkContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
`;

const VacancySoft404 = ({ vacancy }) => {
    return (
        <Page>
            <Helmet>
                <title>Stellenanzeige nicht gefunden</title>
            </Helmet>

            <Robots index={false} />

            <Container slim>
                <Columns>
                    <Columns.Full>
                        <Box>
                            <Box.Content>
                                <Headline>
                                    Stellenanzeige nicht verfügbar
                                </Headline>
                                <p>
                                    Die Stellenanzeige{" "}
                                    <strong>
                                        {vacancy.external_posting_name}
                                    </strong>{" "}
                                    steht nicht mehr zur Verfügung.
                                </p>
                                <p>
                                    Schau in unserer Jobsuche rein - wir haben
                                    viele andere interessante Stellenangebote
                                    für Dich
                                </p>
                                <LinkContainer>
                                    <LinkComponent
                                        button
                                        link={{
                                            href: "/stellenangebote",
                                            text: "Zu den Stellenangeboten",
                                        }}
                                    />
                                </LinkContainer>
                            </Box.Content>
                        </Box>
                    </Columns.Full>
                </Columns>
            </Container>
        </Page>
    );
};

export default VacancySoft404;
